import React from "react";
import Header from "./Header";
import { Helmet } from 'react-helmet-async';
import view from "../assets/header.mp4";
import poster from "../assets/poster.png";
import "./hero.css";

const Hero = () => {
  return (
    <div className="hero-container">
      {/* SEO Etiketleri */}
      <Helmet>
        <title>Gülfem Dikici Çelikay | Klinik Psikolog (MSc)</title>
        <meta
          name="description"
          content="Klinik Psikolog Gülfem Dikici Çelikay ile bireysel terapi, danışmanlık ve psikolojik destek hizmetleri. Online randevu alın."
        />
      </Helmet>

      {/* Video */}
      <video
        className="hero-video"
        src={view}
        autoPlay
        muted
        loop
        playsInline
        poster={poster}
      />

      {/* Video Üzerindeki Yazılar */}
      <div className="text-container d-flex flex-column justify-content-center align-items-center text-center text-white">
        <Header />
      </div>

    </div>
  );
};

export default Hero;
